import { useState } from "react";
import { Alert, Button, Stack, TextField, Typography } from "@mui/material";
import { convertText, EncodingFormat } from "../../utils/developerTools";
import { CopyButton } from "./CopyButton";



type EncodingToolProps = { format: EncodingFormat; };

/**
 * Displays a browser-only UTF-8 encoding and decoding tool.
 * @param props Component configuration.
 * @param props.format Encoding format to use.
 */
export const EncodingTool = (props: EncodingToolProps) => {
	const [ input, setInput ] = useState("");
	const [ output, setOutput ] = useState("");
	const [ error, setError ] = useState("");
	const [ operation, setOperation ] = useState("");
	const convert = (operation: "encode" | "decode") => {
		const result = convertText(input, props.format, operation);
		setOperation(operation === "encode" ? "Encoded output" : "Decoded output");
		setOutput(result.success ? result.value : "");
		setError(result.success ? "" : result.error);
	};
	return (
		<Stack spacing={ 3 }>
			<TextField label="Input" multiline minRows={ 6 } fullWidth value={ input } onChange={ (event) => { setInput(event.target.value); setOutput(""); setError(""); setOperation(""); } } inputProps={{ spellCheck: false }} />
			<Stack direction="row" gap={ 2 } flexWrap="wrap">
				<Button variant="contained" onClick={ () => convert("encode") }>{ props.format === "hex" ? "Encode to Hex" : "Encode" }</Button>
				<Button variant="contained" onClick={ () => convert("decode") }>{ props.format === "hex" ? "Decode from Hex" : "Decode" }</Button>
				<Button variant="outlined" onClick={ () => { setInput(""); setOutput(""); setError(""); setOperation(""); } }>Clear</Button>
			</Stack>
			{ error && <Alert severity="error">{ error }</Alert> }
			<Typography role="status">{ operation }</Typography>
			<TextField label="Output" multiline minRows={ 6 } fullWidth value={ output } inputProps={{ readOnly: true, spellCheck: false }} />
			<CopyButton value={ output } />
			{ props.format === "url" && <Typography>Encodes a value, not a complete URL. Decoding keeps + as a literal plus sign.</Typography> }
		</Stack>
	);
};
